import { FC, ReactElement, useCallback, useState } from 'react';

import { Button, ButtonProps, Tooltip } from '@servicetitan/design-system';

import * as Styles from './copy-box.module.scss';

// eslint-disable-next-line no-restricted-globals
const clipboard = navigator.clipboard;

export interface CopyBoxProps {
    size: number;
    value: string;
    action?: ReactElement<ButtonProps>;
}

export const CopyBox: FC<CopyBoxProps> = ({ size, value, action }) => {
    const [tooltipText, setTooltipText] = useState('');

    const handleCopy = useCallback(async () => {
        try {
            await clipboard.writeText(value);
            setTooltipText('Copied!');
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error('Failed to copy.\n%O', error);
            setTooltipText('Can’t copy');
        }
        setTimeout(() => {
            setTooltipText('');
        }, 8000);
    }, [value]);

    return (
        <div className={Styles.copyBox}>
            <div className="Input Input--medium">
                <div className="Input__InnerWrapper">
                    <input type="text" size={size} readOnly value={value} />
                    {action}
                </div>
                <Tooltip text={tooltipText} portal>
                    <Button iconName="content_copy" disabled={!!tooltipText} onClick={handleCopy}>
                        Copy
                    </Button>
                </Tooltip>
            </div>
        </div>
    );
};
